var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.filter_save },
    [
      _c("filter-header", {
        ref: "header",
        attrs: {
          title: _vm.locales("filter_saving_view"),
          "help-icon": false,
          "back-icon": true,
          "component-name": _vm.componentName,
        },
        on: {
          closeClick: function ($event) {
            return _vm.$emit("onClose")
          },
          backClick: function ($event) {
            return _vm.$emit("backClick")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$.body, style: { height: _vm.height } },
        [
          _c(
            "div",
            { class: _vm.$.filter_name },
            [
              _c("vgp-label-slot", {
                attrs: { label: _vm.locales("filter_saving_view_new_name") },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { class: _vm.$.input },
                          [
                            _c("vgp-input", {
                              ref: "input",
                              attrs: {
                                "is-error": _vm.isNameError,
                                value: _vm.filterName,
                                placeholder: _vm.locales(
                                  "filter_saving_view_new_name"
                                ),
                                small: true,
                              },
                              on: { input: _vm.onInput },
                              model: {
                                value: _vm.filterName,
                                callback: function ($$v) {
                                  _vm.filterName = $$v
                                },
                                expression: "filterName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "scroll", class: [_vm.$.filter_settings, "gantt_scroll"] },
            [
              _vm._l(_vm.filter.staticFilterItems, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _vm.hasValues(item.property)
                      ? _c("vgp-label-slot", {
                          class: [_vm.$.filter_item, _vm.$.slot_item],
                          attrs: { label: item.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("filter-item", {
                                      attrs: {
                                        "filter-item": item,
                                        readonly: true,
                                      },
                                      on: { changeOptions: _vm.changeFilter },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.preparedCustomColumns, function (item, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.$.filter_item },
                  [
                    item.columnsTitle
                      ? _c("div", { class: _vm.$.columns_title }, [
                          _c("div", { class: _vm.$.text }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.columnsTitle) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { class: _vm.$.line }),
                        ])
                      : _c("vgp-label-slot", {
                          class: _vm.$.slot_item,
                          attrs: { label: item.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("filter-item", {
                                      attrs: {
                                        "filter-item": item,
                                        readonly: true,
                                      },
                                      on: {
                                        changeFilter:
                                          _vm.changeCustomFieldsFilter,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("gradient", { attrs: { show: _vm.isShowGradient } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("filter-footers", {
        ref: "footers",
        attrs: { "footer-type": "footer-save" },
        on: {
          onApplyClick: _vm.onApplySaving,
          onCancelClick: function ($event) {
            return _vm.$emit("backClick")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }